<template>
  <div :class="[isHidden ? 'footer-hidden' : 'footer']">
    <section>

      <s-button class="button-support" btn-link="https://www.seedr.cc/faq">{{ $t('footer.support-link') }}</s-button>
      <router-link class="footer-link" to="/about">{{ $t('footer.about-link') }}</router-link>
      <a href="https://www.seedr.cc/faq/" class="footer-link">{{ $t('footer.faq-link') }}</a>
      <a href="https://help.seedr.cc/hc/en-us/requests/new" class="footer-link">{{ $t('footer.contact-us-link') }}</a>
      <router-link class="footer-link" to="/termsofuse">{{ $t('footer.terms-link') }}</router-link>
      <router-link class="footer-link" to="/privacypolicy">{{ $t('footer.Privacy-link') }}</router-link>
      <router-link class="footer-link" to="/dmca">{{ $t('footer.dmca-link') }}</router-link>
    </section>

    <section>
      <p class="footer-copyrights">&copy; {{ $t('footer.date') }} | {{ $t('footer.rights') }}</p>
    </section>
  </div>
</template>

<script>
import SButton from "@/components/SButton.vue";

export default {
  name: 'Footer',
  components: {
    SButton,
  },
  props: {
    msg: String,
    isHidden: Boolean
  }
}
</script>
